import { UserTransactionStatus } from "./account";

export class ReceivableSummary {
  total: number;
  total_more_than_thirty: number;
  total_more_than_sixty: number;
  total_bill: number;
  total_due_date: number;
}

export class Receivable {
  currency_code: string;
  invoice_number: string;
  invoice_date: Date;
  net_value: number;
  credit_value: number;
  due_date: Date;
  Status: string;
  doing_settlement_process: boolean;
}

export class ReceivableSearchRequest {
  lim = 100;
  off = 0;
  filter = 0;
}

export class UserTransaction {
  id: string;
  virtualAccountNumber: string;
  status: UserTransactionStatus;
  paidDate: Date;
  total: number;
  invoiceId: string;
}

export class UserTransactionDetail {
  transferDescription: string;
  accountName: string;
  expiredIn: Date;
  utcNow: Date;
  items: TransactionItem[] = [];
  paymentChannelType: string;
  isCancellable: boolean;
  imagePaymentChannelLogoUrl: string;
  paymentChannelId: string;
  id: string;
  virtualAccountNumber: string;
  status: UserTransactionStatus;
  paidDate: Date;
  total: number;
  invoiceId: string;
}

export class TransactionItem {
  contextId: string;
  invoiceDate: Date;
  price: number;
}

export class PaymentChannel {
  categoryName: string;
  channelDetails: {
    imagePaymentChannelUrl: string;
    code: string;
    bankCode: string;
    name: string;
    description: string;
    isOther: true;
    paymentChannelDetails: [null];
  };
}

export class PaymentChannelDetails {
  name: string;
  isOther: boolean;
  paymentChannelDetails: {
    imagePaymentChannelUrl: string;
    code: string;
    bankCode: string;
    name: string;
    description: string;
    isOther: true;
    paymentChannelDetails: [null];
  };
}

export class ParamPaymentChannelInstructions {
  PaymentChannelId: string;
  VaNumber: string;
}

export class PaymentChannelInstructions {
  title: string;
  body: string;
}
